import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitComplaint, type SubmitComplaintRequest, type SubmitComplaintResponse } from '../api';

/**
 * Hook for submitting complaints
 * Invalidates complaints query on success to refresh lists
 */
export function useSubmitComplaint() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SubmitComplaintRequest): Promise<SubmitComplaintResponse> => {
      return submitComplaint(data);
    },
    onSuccess: () => {
      // Invalidate complaints list to show new complaint
      queryClient.invalidateQueries({ queryKey: ['complaints'] });
    },
  });
}
